import './chunk-6ea13200.js';
import './helpers.js';
import './chunk-17222463.js';
import './chunk-1f14bcfd.js';
import './chunk-d732d84c.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-322704a2.js';
import './chunk-42f463e6.js';
import './chunk-757e4793.js';
import './chunk-f3c004c8.js';
import './chunk-4ecafae5.js';
import { D as Datepicker } from './chunk-0a2a7b70.js';
export { D as BDatepicker } from './chunk-0a2a7b70.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;
